@if (this.iban) {
  <span>{{this.iban | iban}}</span>
}
